export default "__VITE_ASSET__Dle6SiQ1__"